import React from "react";
import moment from "moment";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import AlteredLineDetailNote from "./../shared/altered-linedetail-note.jsx";

export default class TCClockEditItem extends React.Component {
    constructor(props) {
        super(props);

        this.onDeleteLineDetail = this.onDeleteLineDetail.bind(this);
    }

    onEditLineDetail(tcLineDetailId) {
        const self = this;
        if (self.props.onEditTcLineDetail) self.props.onEditTcLineDetail(tcLineDetailId);
    }

    onDeleteLineDetail(tcLineId, tcLineDetailId) {
        const self = this;
        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to delete this record?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is tcLineDetailId, tcLineDetailId is set as the 3rd parameter of context.message            
            if (button === "yes") {
                ajax.api()
                    .delete(`delete-tc-line-detail/${s.tcLineId}/${s.tcLineDetailId}`)
                    .then(function (res) {
                        if (self.props.onDeleteTcLineDetail) self.props.onDeleteTcLineDetail(res.data);
                    })
                    .catch(function (err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"
                        });
                    });
            }
        }, { tcLineId: tcLineId, tcLineDetailId: tcLineDetailId });
    }

    render() {
        let vm = this.props.vm;
        const showAltered = (this.props.showAltered == true || (this.props.showAltered && this.props.showAltered.toLowerCase() == "true"));
       
        let allowEdit = `${this.props.allowEdit}` == "true";
        const tcStatus = this.props.timecardStatus
        if (tcStatus == "Processed") {
            allowEdit = allowEdit && vm.timecardLine.statusCode == "Processed";
        }

        const lines = []
        for (let i = 0; i < vm.timecardLineDetails.length; i++) {
            let line = vm.timecardLineDetails[i];

            let incompleteText = line.clockOut === null ? "ap-color-red" : "";
            let incompleteHidden = line.clockOut === null ? "ap-hidden" : "";
            let lineDiv = null;
            let total = moment.duration(moment(line.clockOut) - moment(line.clockIn));
            if (i == 0) {
                lineDiv = <div className="row" key={line.timecardDetailLineId}>
                    <div className="col-md-2 hidden-xs hidden-sm ap-unwrap-content">
                        {moment(vm.timecardLine.dayDate).format("dddd MMM D")}
                    </div>
                    <div className="col-sm-12 hidden-md hidden-lg">
                        <span className="ap-work-item-day">{moment(vm.timecardLine.dayDate).format("dddd MMM D")}</span>
                    </div>
                    <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                        <b>In</b>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-1 ap-unwrap-content">
                        <span className={incompleteText}>{moment(line.clockIn).format("h:mm A")}</span>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-2 ap-unwrap-content">
                        <span className={incompleteText}>{line.inReason}</span>
                    </div>
                    <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                        <b>Out</b>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-1 ap-unwrap-content">
                        <span className={incompleteHidden}>{moment(line.clockOut).format("h:mm A")}</span>
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-2 ap-unwrap-content">
                        <span className={incompleteHidden}>{line.outReason}</span>
                    </div>
                    <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                        <b>Total</b>
                    </div>
                    <div className="col-xs-10 col-sm-10 col-md-1 ap-unwrap-content">
                        <span className={incompleteHidden}>{total.hours()} hr {total.minutes()} min</span>
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-1">{
                        (allowEdit) ?
                            <a href="#" onClick={() => this.onDeleteLineDetail(vm.timecardLine.timecardLineId, line.timecardDetailLineId)}>
                                <i className="fa fa-trash-o"></i>
                            </a> : null
                    }
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-1"> {
                        (allowEdit) ?
                            <a href="#" data-id={line.timecardDetailLineId} onClick={() => this.onEditLineDetail(line.timecardDetailLineId)}>
                                <i className="fa fa-pencil-square-o"></i>
                            </a> : null
                    }
                    </div>
                    <div className="col-xs-4 col-sm-4 col-md-1"> {(line.isAltered && showAltered) ? <AlteredLineDetailNote vm={line} /> : null}</div>
                </div>
            } else {
                lineDiv = (
                    <div className="row ap-top-margined" key={line.timecardDetailLineId}>
                        <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                            <b>In</b>
                        </div>
                        <div className="col-md-offset-2 col-xs-4 col-sm-4 col-md-1 ap-unwrap-content">
                            <span className={incompleteText}>{moment(line.clockIn).format("h:mm A")}</span>&nbsp;
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-2 ap-unwrap-content">
                            <span className={incompleteText}>{line.inReason}</span>&nbsp;
                        </div>
                        <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                            <b>Out</b>
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-1 ap-unwrap-content">
                            <span className={incompleteHidden}>{moment(line.clockOut).format("h:mm A")}</span>&nbsp;
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-2 ap-unwrap-content">
                            <span className={incompleteHidden}>{line.outReason}</span>&nbsp;
                        </div>
                        <div className="col-xs-2 col-sm-2 col-md-1 hidden-md hidden-lg">
                            <b>Total</b>
                        </div>
                        <div className="col-xs-10 col-sm-10 col-md-1 ap-unwrap-content">
                            <span className={incompleteHidden}>{total.hours()} hr {total.minutes()} min</span>&nbsp;
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-1">{
                            (allowEdit) ?
                                <a href="#" onClick={() => this.onDeleteLineDetail(vm.timecardLine.timecardLineId, line.timecardDetailLineId)}>
                                    <i className="fa fa-trash-o"></i>
                                </a> : null
                        }
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-1">{
                            (allowEdit) ?
                                <a href="#" data-id={line.timecardDetailLineId} onClick={() => this.onEditLineDetail(line.timecardDetailLineId)}>
                                    <i className="fa fa-pencil-square-o"></i>
                                </a> : null
                        }
                        </div>
                        <div className="col-xs-4 col-sm-4 col-md-1"> {(line.isAltered && showAltered) ? <AlteredLineDetailNote vm={line} /> : null}</div>
                    </div>
                );
            }
            lines.push(lineDiv);
        }

        return (
            <div className="ap-work-item-container">
                <div className="ap-work-item-list container-fluid ap-border-color-lightgray ap-color-darkgray">
                    {lines}
                </div>
                <div className="ap-work-item-summary container-fluid ap-top-margined ap-bkg-color-lightgray ap-color-darkgray container-fluid">
                    <div className="row">
                        <div className="col-xs-4 col-sm-4 col-md-2 col-lg-2">
                            {moment(vm.timecardLine.dayDate).format("dddd")} Total :
                        </div>
                        <div className="col-xs-8 col-sm-8 col-md-3 col-lg-3">
                            Regular: {vm.timecardLine.regularHour} hour(s) {vm.timecardLine.regularMin} minute(s)
                        </div>
                        <div className="col-xs-offset-4 col-sm-offset-4 col-md-offset-0 col-lg-offset-0 col-xs-8 col-sm-8 col-md-3 col-lg-3">
                            OT: {vm.timecardLine.otHour} hour(s) {vm.timecardLine.otMin} minute(s)
                        </div>
                        <div className="col-xs-offset-4 col-sm-offset-8 col-md-offset-0 col-lg-offset-0 col-xs-8 col-sm-8 col-md-3 col-lg-3">
                            DT: {vm.timecardLine.dtHour} hour(s) {vm.timecardLine.dtMin} minute(s)
                        </div>
                    </div>
                </div>
            </div>);
    }
}